import { Navigate, useLocation, useRoutes } from "react-router-dom";
import { useAuth } from "src/common/auth";
import { AppLayout } from "../App";
import { AccessKeys, AuthVisitors, Houses, Login, Logs, Users } from "./index";

export default function RouterElement() {
  const element = useRoutes(
    // FIX check for proper default route
    [
      {
        index: true,
        path: "/",
        element: <Login />,
      },
      // Protected routes
      {
        element: <AppLayout />,
        children: [
          {
            path: "/logs",
            element: (
              <RequireAuth>
                <Logs />
              </RequireAuth>
            ),
          },
          {
            path: "/access-keys",
            element: (
              <RequireAuth>
                <AccessKeys />
              </RequireAuth>
            ),
          },
          {
            path: "/users",
            element: (
              <RequireAuth>
                <Users />
              </RequireAuth>
            ),
          },
          {
            path: "/houses",
            element: (
              <RequireAuth>
                <Houses />
              </RequireAuth>
            ),
          },
          {
            path: "/auth-visitors",
            element: (
              <RequireAuth>
                <AuthVisitors />
              </RequireAuth>
            ),
          },
        ],
      },
    ],
  );

  return element;
}

/**
 * Redirects to the login page, but saves the current location a user
 * tried to go to when they were redirected. This allows to send them
 * along to that page after login, which is a nicer user experience
 * than dropping them off on the home page.
 * Modified from: https://reactrouter.com/docs/en/v6/examples/auth */
function RequireAuth({ children }: { children: JSX.Element }) {
  // TODO from react-query
  const auth = useAuth();
  // let auth = true;
  // let auth = queryClient.getQueryData("userAuth");

  const location = useLocation();

  if (!auth) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}
